import { ATTRIBUTES_FORM_NAMES } from '@t/api/audience/form/attribute-names.type';

import { SearchType } from 'types/api/audience/enums/search-type.enum';
import { ObjectValues } from 'types/common';

import { DATA_SOURCE_FORM_NAMES } from './data-source-names.type';
import { LOCATION_FORM_NAMES } from './location-names.type';
import { TAG_FORM_NAMES } from './tag-names.type';

export const FORM_NAMES = {
  AbOrder: `${SearchType.AbOrder}`,
  Attributes: `${SearchType.Attributes}`,
  Basic: `${SearchType.Basic}`,
  Clients: `${SearchType.DataSource}.${DATA_SOURCE_FORM_NAMES.Clients}`,
  ClientTags: `${SearchType.Tags}.${TAG_FORM_NAMES.ClientTags}`,
  Conditions: `${SearchType.Conditions}`,
  CongressionalDistricts: `${SearchType.CongressionalDistricts}`,
  ExcludeBusiness: `${SearchType.Attributes}.${ATTRIBUTES_FORM_NAMES.ExcludeBusiness}`,
  ExternalLists: `${SearchType.DataSource}.${DATA_SOURCE_FORM_NAMES.ExternalLists}`,
  Gender: `${SearchType.Attributes}.${ATTRIBUTES_FORM_NAMES.IncludeGender}`,
  HouseOrder: `${SearchType.HouseOrder}`,
  IncludeNonDonor: `${SearchType.Attributes}.${ATTRIBUTES_FORM_NAMES.IncludeNonDonor}`,
  IncludeOutOfStateDonor: `${SearchType.Attributes}.${ATTRIBUTES_FORM_NAMES.IncludeOutOfStateDonor}`,
  ListRentals: `${SearchType.ListRentals}`,
  Lists: `${SearchType.DataSource}.${DATA_SOURCE_FORM_NAMES.Lists}`,
  MailCodes: `${SearchType.MailCodes}`,
  MailCodeTags: `${SearchType.Tags}.${TAG_FORM_NAMES.MailCodeTags}`,
  MasterFile: `${SearchType.DataSource}.${DATA_SOURCE_FORM_NAMES.MasterFile}`,
  Omits: `${SearchType.Omits}`,
  PackageTags: `${SearchType.Tags}.${TAG_FORM_NAMES.PackageTags}`,
  Scf: `${SearchType.Locations}.${LOCATION_FORM_NAMES.Scf}`,
  Sequences: `${SearchType.Sequences}`,
  States: `${SearchType.Locations}.${LOCATION_FORM_NAMES.States}`,
  ThirdParty: `${SearchType.DataSource}.${DATA_SOURCE_FORM_NAMES.ThirdParty}`,
  UseClientLists: `${SearchType.DataSource}.${DATA_SOURCE_FORM_NAMES.UseClientLists}`,
  Zips: `${SearchType.Locations}.${LOCATION_FORM_NAMES.Zips}`,
} as const;

export type FormNames = ObjectValues<typeof FORM_NAMES>;
